export default __webpack_public_path__ + "files/445487731029b42ebfc82250634ecf09.png";